import React from 'react';

const PaymentPage = () => {
    return (
        <div>
            <h1>Pay to get u product early er</h1>
        </div>
    );
};

export default PaymentPage;